import { Grid } from "@mui/material";
import GKTable from "components/GKTable";

const Investor = () => {
  const columns = [
    {
      headerName: "User Details",
      field: "companyName",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Mobile no.",
      field: "number",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Email",
      field: "email",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Portfolio Count",
      field: "portfoliocount",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Payment Date",
      field: "paymentdate",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Last Used",
      field: "lastdate",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Access",
      field: "access",
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: "Action",
      field: "action",
      disableColumnMenu: true,
      flex: 1,
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <GKTable
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          sx={{ height: 470, width: "100%" }}
          checkboxSelection
        />
      </Grid>
    </Grid>
  );
};

export default Investor;
